import styled from 'styled-components';
import clock from '~/assets/icons/clock.svg';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/confirm_bg.png';

const StyledContainer = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 20;
	width: 100%;
	height: 100%;
	opacity: 0;
	background-color: rgba(17, 19, 20, 0.95);
	transition: opacity 0.3s ease;

	&.confirm-enter {
		opacity: 0;
	}

	&.confirm-enter-active,
	&.confirm-enter-done,
	&.confirm-exit {
		opacity: 1;
	}

	&.confirm-exit-active {
		opacity: 0;
	}
`;

const StyledBackground = styled.div`
	position: absolute;
	width: 2000px;
	height: 2000px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledCenterContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 30px;
`;

const StyledTimerContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 20px;

	${Text} {
		&:nth-child(2) {
			font-weight: 500;
			font-size: 18px;
			line-height: 21px;
			color: #fabe2c;
		}

		&:nth-child(3) {
			width: 390px;
			font-style: italic;
			font-weight: 400;
			font-size: 16px;
			line-height: 18px;
			text-align: center;
			color: #ffffff;
			opacity: 0.25;
		}
	}
`;

const StyledClockIcon = styled.div`
	width: 30px;
	height: 30px;
	mask-image: url(${clock});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: contain;
	-webkit-mask-image: url(${clock});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: contain;
	background-color: #fabe2c;
`;

const StyledCancelButton = styled.button`
	height: 40px;
	padding: 0 20px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;
	border: 0;
	cursor: pointer;
	user-select: none;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}
`;

const StyledButtonsContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;

	button {
		width: 100%;
	}
`;

const StyledConfirmButton = styled.button`
	height: 40px;
	padding: 0 20px;
	background-color: #1f8034;
	border-radius: 10px;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 18px;
	color: #ffffff;
	border: none;
	user-select: none;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:not(&:disabled) {
		cursor: pointer;
	}

	&:not(&:disabled):hover {
		background-color: #ffffff;
		color: #000000;
	}

	&:disabled {
		background-color: rgba(255, 255, 255, 0.05);
		color: rgba(255, 255, 255, 0.25);
	}
`;

export {
	StyledBackground,
	StyledButtonsContainer,
	StyledCancelButton,
	StyledCenterContainer,
	StyledClockIcon,
	StyledConfirmButton,
	StyledContainer,
	StyledTimerContainer,
};
